<template>
  <div class="FuZhuang">
    <!--春季：1-3月-->
    <div class="spring" v-if="nowMoth >= 3 && nowMoth <= 5">
      <div class="banner">
        <img width="100%" src="../../../assets/img/FuZhuang/FuZhuang_Banner_spring.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/FuZhuang/FuZhuang_yingtao_spring.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/FuZhuang/spring_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              富庄镇甜樱桃种植面积约11000亩，冬暖夏凉，四季分明。海拔1100-1700米的种植范围、1475.8小时
              的年均日照时数、山地影响形成的昼夜温差，和远离城市工业污染的良好生态环境，为甜樱桃的生长提供了绝佳的自然气候条件，形成了果实鲜艳、果皮弹牙、果肉肥厚、味道酸甜适口，可溶性固形物含量在15-24%，单果重10-12克的解馋佳品。因其营养丰富、医养保健价值充沛，被誉为“果中珍品”和“宝石水果”。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/FuZhuang/FuZhuang_jianjiePic_spring.png"
                alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuZhuang/spring_square.png')"
        color="#AD001E" borderBottomColor="#AD001E" boxBorderColor="#E5C8CF" btnBJcolor="#D47D8E" hoverBJcolor="#AF0124">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuZhuang/spring_square.png')"
        color="#AD001E" borderBottomColor="#AD001E"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/FuZhuang/spring_square.png')" color="#AD001E"
        borderBottomColor="#AD001E" boxBorderColor="#E5C8CF"></ztxzList>
    </div>
    <!-- 四季 -->
    <div class="winter" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/FuZhuang/FuZhuang_Banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/FuZhuang/FuZhuang_lihuaPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/FuZhuang/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              富庄镇同义村种植的汉源大白梨树(以下简称古梨树)，栽培历史悠久，具有果实大、抗性强、产量高、耐贮存的优点，是汉源优良的地方梨品种。富庄镇同义村有100年以上古梨树189株，50-100年古梨树701株，共计890株。古树名木是自然历史文化遗产的重要组成部分，是活的文物，具有重要的生态、科研、人文、地理、旅游等方面价值。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/FuZhuang/FuZhuang_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuZhuang/square.png')"
        color="#2F7FC8" borderBottomColor="#2F7FC8" boxBorderColor="#D4E0F2" btnBJcolor="#94BCE0" hoverBJcolor="#2E7FC8">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuZhuang/square.png')"
        color="#2F7FC8" borderBottomColor="#2F7FC8"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/FuZhuang/square.png')" color="#2F7FC8"
        borderBottomColor="#2F7FC8" boxBorderColor="#D4E0F2"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
// import { getServerDate, matterQuery, getVillages } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'富庄镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // } else {
  //   //   if (sessionStorage.getItem('mapId')) {
  //   //     this.mapId = sessionStorage.getItem('mapId');
  //   //   }
  //   // }

  //   this.getData()
  //   this.GetVillages() 
  //   setTimeout(() => {
  //    this.getMatterList()
  //   }, 1000);
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取乡镇列表
  //   GetVillages() {
  //     getVillages().then(res => {
  //       // console.log(res, '乡镇列表')
  //       if (res.status == 200) {
  //         if (res.data.data && res.data.data.length > 0) {
  //           let arrList = res.data.data;
  //           arrList.unshift({ type: null, mapId: "fa08802c1d4d11eda7660242ac120002", name: "县本级" });
  //           for (let index = 0; index < arrList.length; index++) {
  //             switch (arrList[index].name.slice(0, 2)) {
  //               case '县本':
  //                 arrList[index].url = 'HanYuan'
  //                 break;
  //               case '安乐':
  //                 arrList[index].url = 'AnLe'
  //                 break;
  //               case '大树':
  //                 arrList[index].url = 'DaShu'
  //                 break;
  //               case '富林':
  //                 arrList[index].url = 'FuLin'
  //                 break;
  //               case '富泉':
  //                 arrList[index].url = 'FuQuan'
  //                 break;
  //               case '富乡':
  //                 arrList[index].url = 'FuXiang'
  //                 break;
  //               case '富庄':
  //                 arrList[index].url = 'FuZhuang'
  //                 break;
  //               case '河南':
  //                 arrList[index].url = 'HeNan'
  //                 break;
  //               case '皇木':
  //                 arrList[index].url = 'HuangMu'
  //                 break;
  //               case '九襄':
  //                 arrList[index].url = 'JiuXiang'
  //                 break;
  //               case '马烈':
  //                 arrList[index].url = 'MaLie'
  //                 break;
  //               case '坭美':
  //                 arrList[index].url = 'NiMei'
  //                 break;
  //               case '片马':
  //                 arrList[index].url = 'PianMa'
  //                 break;
  //               case '前域':
  //                 arrList[index].url = 'QianYu'
  //                 break;
  //               case '清溪':
  //                 arrList[index].url = 'QingXi'
  //                 break;
  //               case '晒经':
  //                 arrList[index].url = 'ShaiJin'
  //                 break;
  //               case '顺河':
  //                 arrList[index].url = 'ShunHe'
  //                 break;
  //               case '唐家':
  //                 arrList[index].url = 'TangJia'
  //                 break;
  //               case '乌斯':
  //                 arrList[index].url = 'WuSiHe'
  //                 break;
  //               case '小堡':
  //                 arrList[index].url = 'XiaoBao'
  //                 break;
  //               case '富泉':
  //                 arrList[index].url = 'FuQuan'
  //                 break;
  //               case '宜东':
  //                 arrList[index].url = 'YiDong'
  //                 break;
  //               case '永利':
  //                 arrList[index].url = 'YongLi'
  //                 break;
  //               default:
  //                 break;
  //             }
  //           }
  //           // console.log(arrList,'结果')
  //           this.villages = arrList;
  //           let obj = this.villages.find(el => el.name == this.name);
  //           if (obj) {
  //             this.mapId = obj.mapId;
  //           }
  //         }
  //       } else {
  //         this.$message.error('获取乡镇列表失败！')
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.FuZhuang {
  background: url('../../../../src/assets/img/FuZhuang/FuZhuang_bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.spring .top_title {
  color: #AD001E;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #AD001E;
  height: 12%;
}

.winter .top_title {
  color: #2F7FC8;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #2F7FC8;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}
</style>